import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type PhysicalDeliveryState = {
  [key: string]: any;
  delivery_type: number | string;
  currency_id: number;
  format: number | string;
  deliveryType: any[];
  new: boolean;
};

const INITIAL_STATE: PhysicalDeliveryState = {
  delivery_type: '3',
  currency_id: 1,
  format: '1',
  deliveryType: [],
  new: true
};

type PhysicalDeliveryStore = {
  delivery: PhysicalDeliveryState;
  readonly setDelivery: (delivery: PhysicalDeliveryState) => void;
  readonly updateDelivery: (partial: Partial<PhysicalDeliveryState>) => void;
  readonly reset: () => void;
};

export const physicalDeliveryStore = create<PhysicalDeliveryStore>(set => ({
  delivery: { ...INITIAL_STATE },
  setDelivery: delivery => set({ delivery: { ...delivery } }),
  updateDelivery: partial => set(state => ({ delivery: { ...state.delivery, ...partial } })),
  reset: () => set({ delivery: { ...INITIAL_STATE, deliveryType: [] } })
}));

export const usePhysicalDeliveryStore = <T = PhysicalDeliveryStore>(
  selector: (state: PhysicalDeliveryStore) => T = state => state as T
) => physicalDeliveryStore(useShallow(selector));
